import { useCallback, useState } from 'react';

//* HOC's
import { withUserContext, withUIContext, withLanguageContext } from 'context';

//* Components
import FormContainer from 'components/common/FormContainer';
import FormItem from 'components/common/FormItem';
import FormInput from 'components/common/FormInput';
import Text from 'components/common/Text';
import Button from 'components/common/Button';
import LoginPopup from 'components/common/Popups/LoginPopup';

//* Style
import ForgotPasswordStyle from './style';

const ForgotPassword = ({ forgotPassword, openPopup, translate }) => {
	//! States
	const [isSend, setIsSend] = useState(false);

	const onFinish = useCallback((values) => {
		setIsSend('loading');

		return forgotPassword(values)
			.then(() => {
				setIsSend(true);

				setTimeout(() => {
					setIsSend(false);
				}, 3000);
			})
			.catch((err) => {
				setIsSend(false);

				return Promise.reject(err);
			});
	}, []);

	//! Open Login popup
	const handleSignIn = useCallback(() => {
		openPopup(<LoginPopup />);
	}, [openPopup]);

	return (
		<>
			<ForgotPasswordStyle />

			<div className='forgot-content-wrap'>
				<Text
					className={'h4 font-ping-medium forgot-title'}
					text={'forgotPasswordPopup'}
				/>

				<Text
					className={'pS font-ping-medium forgot-description'}
					text={'forgotPopupDescription'}
				/>

				{isSend && isSend !== 'loading' ? (
					<Text
						className={'font-ping-medium success-message pXS successColor'}
						text={'emailSuccess'}
					/>
				) : null}

				<FormContainer onFinish={onFinish}>
					<FormItem
						name={'email'}
						validationType={'email'}
						className={'form-item'}>
						<FormInput placeholder={`${translate('email')}*`} />
					</FormItem>

					<div className='forgot-buttons-wrap'>
						<Text
							className='pS sign-in colorBigStone underline font-ping-bolder'
							text={'login'}
							onClick={handleSignIn}
						/>

						<Button
							text={'sendEmail'}
							type={'icon-aside'}
							className={'send-email-button'}
							disabled={isSend === 'loading'}
							isBtnLoad={isSend === 'loading'}
						/>
					</div>
				</FormContainer>
			</div>
		</>
	);
};

export default withLanguageContext(withUIContext(withUserContext(ForgotPassword, ['forgotPassword']), ['closePopup', 'openPopup']), ['translate']);
